
export default {
  name: 'GcReducedPrice',
  data() {
    return {
      className: 'gc__reduced-price',
    };
  },
  computed: {
    originalPriceClassName() {
      return `${this.className}__original-price`;
    },
    discountedPriceClassName() {
      return `${this.className}__discounted-price`;
    },
    strikeClassName() {
      return this.discountedPrice ? `${this.className}--strike` : '';
    },
    blueFontClassName() {
      return this.blueDiscountFont ? `${this.className}--blue` : '';
    },
  },
  props: {
    originalPrice: {
      type: [String, Number],
      default: '',
      required: true,
    },
    discountedPrice: {
      type: [String, Number],
      default: '',
    },
    blueDiscountFont: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
